export const baseInputSx = {
  InputProps: {
    sx: { height: '40px', width: '200px' },
  },
};
